import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import { useState } from "react"

import DialogProvider from "@components/dialog_provider"
import { useCustomerPageContext } from "@contexts/customer"
import { goToCustomerSessionByAdmin } from "@domain/customer/infos"
import useControlledForm from "@hooks/use_controlled_form"
import { useQueryClient } from "@tanstack/react-query"
import { showErrorToast } from "@utils/toast"

export default function CustomerAccessAccount({
  isOpen,
  setClose,
  selectedRowId
}: {
  isOpen: boolean
  setClose: () => void
  selectedRowId?: string
}) {
  const { translate } = useCustomerPageContext()
  const [loading, setLoading] = useState(false)
  const queryClient = useQueryClient()

  const USER_PANEL_LOGIN_URL = process.env.REACT_APP_USER_PANEL_URL

  const {
    formState: { isValid }
  } = useControlledForm({
    mode: "all"
  })

  function handleClose() {
    if (loading) {
      return
    }
    setClose()
  }

  async function onSubmit() {
    if (!selectedRowId) {
      return
    }
    setLoading(true)
    const {
      isSuccess,
      errorMessage,
      data: responseData
    } = await goToCustomerSessionByAdmin({ customerId: selectedRowId })
    if (!isSuccess || !responseData) {
      setLoading(false)
      showErrorToast(String(errorMessage))
      return
    }

    const response = responseData.data

    window.open(
      `${USER_PANEL_LOGIN_URL}/private/loginbyadmin?token=${response.token}&cPersonId=${response.cPerson._id}`,
      "_blank"
    )
    queryClient.invalidateQueries({ queryKey: ["customer-data-table"] })
    setLoading(false)
    handleClose()
  }

  return (
    <DialogProvider
      title={translate("access_customer_account")}
      leftButton={{
        text: translate("cancel"),
        color: "secondary",
        onClick: handleClose,
        disabled: loading
      }}
      rightButton={{
        text: translate("access"),
        color: "primary",
        onClick: onSubmit,
        loading: loading,
        disabled: !isValid
      }}
      isOpen={isOpen}
      setClose={handleClose}
      size="small"
    >
      <Stack justifyContent={"center"} alignItems={"center"} flex={1}>
        <Typography align="center">
          {translate("access_customer_account_text")}
        </Typography>
      </Stack>
    </DialogProvider>
  )
}
